
	var background="",
     color="",
     hoverBackground="",
     hoverColor="";
     textWord="Customize Now";
  $.ajax({  
    type : "get",  
    url : "https://prisrv.uniprocessing.com/omniPersonalityFDB/front/customButton/get",  
    dataType:"json",
    async : false,
    success : function(data){  
      console.log(data)
      textWord=data.text;
      background=data.background;
      color=data.color;
      hoverBackground=data.hoverBackground;
      hoverColor=data.hoverColor;
    },
    error: function(err){
      console.log(err)
    }
  });
let shopifyCustomize, pruIdCustomize=$(".scriptClass").attr("id"), changeDiv, intoDIv;
let aaa = 'Debut';
if(aaa === 'supply') {
  // supply
  shopifyCustomize = $("#productSelect-product-template option:selected"); // 获取到id
  changeDiv = $("#addToCartForm-product-template") // 点击切换sku位置
  intoDIv = $(".shopify-payment-button") // 插入的html
} else if (aaa === "Debut") {
	shopifyCustomize = $("#ProductSelect-product-template option:selected").val(); // 获取到id
    changeDiv = $(".selector-wrapper") // 点击切换sku位置
    intoDIv = $(".product-form__item--submit") // 插入的html
}
  text(shopifyCustomize);
  changeDiv.change(function(){
     let changeVariant;
      if(aaa === 'supply') {
        changeVariant = $("#productSelect-product-template option:selected").val()
      } else if (aaa === "Debut") {
        changeVariant = $("#ProductSelect-product-template option:selected").val()
      }
      text(changeVariant);
    
  }) 
  function text(shopifyVar) {
    jQuery.getJSON('https://prisrv.uniprocessing.com/omniPersonalityFDB/front/product/getProductCustomization?productId=' +pruIdCustomize, function(result){
    console.log(result);
    if ( result ){
      $(".setLs").remove()
        var the_button = $('button[name=add]');
      	the_button.attr('name', 'button')
        the_button.attr('type', 'button')
        the_button.css({padding: 0, background: background, color: color, display: 'block'})
        the_button.after(`<p class="mt20" style="margin-top:20px;display: flex;"><input type="checkbox" id="myCheckbox" > <span style="margin-left:5px;color: #f35a00;font-weight: 600;font-size: 15px;">I'm sure that Findingbox has my design artwork already.</span></p>`)
//         the_button.attr('class', '')
            if(shopifyVar!==undefined){
              the_button.html(`<a href="https://${window.location.host}/apps/dist/index.html?id=${pruIdCustomize}&variant=${shopifyVar}" class="shopifyHref"
style="background:${background};color:${color};width:100%;display:block;padding:10px 0;"
                id="customify-link">
                ${textWord}</a>`)    
                product_formsubmit.css('display', 'block')
                $(document).on('change','#myCheckbox',function(){
                  if ($(this).is(':checked')) {
                      // 如果多选框选中，则显示列表
                      var the_button = $('button[name=button]');
                    	the_button.attr('name', 'add')
                      the_button.attr('type', 'submit')
                      the_button.css({background:'#006eff', color:'#fff' })
                    the_button.html(`Add to Cart`)
                    } else {
                      // 如果多选框不选中，则隐藏列表
                      the_button = $('button[name=add]');
                      the_button.attr('name', 'button')
                      the_button.attr('type', 'button')
                      the_button.css({padding: 0, background: background, color: color, display:'block'})
                    the_button.html(`<a href="https://${window.location.host}/apps/dist/index.html?id=${pruIdCustomize}&variant=${shopifyVar}" class="shopifyHref"
              style="background:${background};color:${color};width:100%;display:block;padding:10px 0;"
                      id="customify-link">
                      ${textWord}</a>`)  
                    }
                })
                                                      
             } else {
              the_button.html.html('<a  data-handle="{{product.handle}}" data-product="{{product.id}}" id="customify-link"  class="btn product-form__cart-submit btn--secondary-accent">已售罄</a>')                                     
             }
            
          } else {
          $('form[action="/cart/add"] *[type="submit"]').show();
        }
     })
  }
  $(document).on('mouseover','.shopifyHref',function(){
    $(this).css({background:hoverBackground,color:hoverColor})
  })

  $(document).on('mouseout','.shopifyHref',function(){
    $(this).css({background:background,color:color})
  })



  